import React, { MutableRefObject, ReactElement, useEffect } from "react";
import {
    OverlayTrigger, Popover,
} from "react-bootstrap";
import { RiCloseLine } from "react-icons/ri";

import { User } from "../../__generated__/api";
import Avatar from "../avatar/Avatar";
import IntegrationUserData from "../integration-user-data/IntegrationUserData";
import Styles from "./UserOverlay.module.scss";

interface PopperProps {
    className: string;
    popper?: {scheduleUpdate:() => void};
    children: ReactElement;
}
const UpdatingPopover = React.forwardRef<unknown, PopperProps>(
    ({
        popper, children, className, ...props
    }, ref) => {
        useEffect(() => {
            popper?.scheduleUpdate();
        }, [children, popper]);

        return (
            <Popover
                className={className}
                ref={ref as MutableRefObject<HTMLDivElement>}
                body
                {...props}
            >
                {children}
            </Popover>
        );
    },
);
UpdatingPopover.defaultProps = {
    popper: undefined,
};

export default function UserOverlay({
    user, onToggleShow, shouldShow, children, size, placement,
}: {
    user: User,
    onToggleShow: (shouldShow: boolean) => void,
    shouldShow: boolean,
    children: ReactElement,
    size?: "sm" | "lg",
    placement?: "right" | "left"
}): ReactElement {
    const renderUser = (
        <UpdatingPopover className={`${Styles["user-card"]} ${size === "lg" ? Styles["user-card-wide"] : ""}`}>
            <div className="m-n3">
                <button
                    className="float-end btn btn-none h-0 p-0 mx-3 ms-n3"
                    type="button"
                    onClick={() => onToggleShow(false)}
                >
                    <RiCloseLine />
                </button>

                <div className="d-flex justify-content-center flex-column mt-2 border-bottom">
                    <Avatar src={user.avatarUrl as string} variant="md" className="m-auto" />

                    <h4 className="text-center mt-2">
                        {user.name}
                    </h4>
                    <div className="text-center mb-2">
                        {user.group}
                    </div>
                </div>
                <IntegrationUserData userId={user.id} />
            </div>
        </UpdatingPopover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement={placement}
            overlay={renderUser}
            show={shouldShow}
        >
            {children}
        </OverlayTrigger>

    );
}

UserOverlay.defaultProps = {
    size: "sm",
    placement: "right",
};
